// extracted by mini-css-extract-plugin
module.exports = {"label":"_oi","checkboxIcon":"_oj","disabled":"_ok","checked":"_ol","option":"_om","optionContainer":"_on"};